import { useNavigate } from 'react-router-dom';
import { IconBell, IconChevronDown, IconLogout, IconUser } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';
import { useUnreadNotificationCount } from '@/hooks/useNotifications';
import { Avatar } from '@/components/ui/Avatar';
import { Dropdown } from '@/components/ui/Dropdown';
import { IconButton } from '@/components/ui/IconButton';
import { Breadcrumbs } from '@/components/layout/Breadcrumbs';

export function Topbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { data: unreadCount } = useUnreadNotificationCount();

  return (
    <header className="sticky top-0 z-stickyNav flex h-[72px] shrink-0 items-center justify-between border-b border-border-subtle bg-bg-base/80 px-6 backdrop-blur-nav">
      <Breadcrumbs />

      <div className="flex items-center gap-3">
        <div className="relative">
          <IconButton label="Notifications" onClick={() => navigate('/notifications')}>
            <IconBell className="h-[18px] w-[18px]" />
          </IconButton>
          {Boolean(unreadCount) && (
            <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-brand-primary px-1 text-[10px] font-bold text-text-primary">
              {unreadCount! > 9 ? '9+' : unreadCount}
            </span>
          )}
        </div>

        <Dropdown
          align="right"
          trigger={
            <button className="focus-ring flex items-center gap-2 rounded-full py-1 pl-1 pr-2 transition-colors hover:bg-bg-surface-hover">
              <div className="rounded-full bg-brand-gradient p-[1.5px]">
                <Avatar name={user?.name ?? ''} src={user?.avatar_url} size={32} />
              </div>
              <span className="hidden text-sm font-medium text-text-primary sm:block">{user?.name}</span>
              <IconChevronDown className="h-3.5 w-3.5 text-text-tertiary" />
            </button>
          }
          items={[
            { label: 'My Profile', icon: <IconUser className="h-4 w-4" />, onClick: () => navigate('/profile') },
            { label: 'Log out', icon: <IconLogout className="h-4 w-4" />, onClick: () => logout(), danger: true },
          ]}
        />
      </div>
    </header>
  );
}
